<template>
  <!-- 外部訂單拒單 -->
  <cus-dialog>
    <template v-slot:body>
      <div style="padding: 0 4px; font-size: 18px">
        是否確定要拒單？
        <br />
        <br />
      </div>
    </template>
    <template v-slot:footer>
      <div class="d-flex">
        <cus-button text="取消" color="white" :width="50" @click="close"></cus-button>
        <cus-button text="確定" color="blue" :width="50" @click="submit({ input_reason, select_reason })"></cus-button>
      </div>
    </template>
  </cus-dialog>
</template>
<script>
import { inject, ref } from 'vue';

export default {
  name: 'reject-order',
  setup() {
    // const { proxy } = getCurrentInstance();
    //接受provide值
    const { cusProps } = inject('cusProps');
    const close = inject('close');
    const submit = inject('submit');

    //建立參數
    const input_reason = ref('');
    const select_reason = ref('外部0元訂單');

    return {
      close,
      submit,
      cusProps,
      input_reason,
      select_reason,
    };
  },
};
</script>
